﻿/*
 * Purpose: Compose AuthForm by wiring useAuthForm state into layout.
 * Boundary: Composition only; delegates UI to layout; no styling or logic.
 * Invariants:
 * - Accepts optional mode prop ('login' | 'register'); defaults to 'login'.
 * - ASCII only; all comments and strings are plain text.
 */

// Imports
import AuthFormLayout from "./authform/authform-layout";

import { createContext } from 'react';
import { useAuthForm } from "./authform/authform-hooks";

export const AgeContext = createContext();

// Component AuthForm:
// Headless wrapper that connects useAuthForm state to AuthFormLayout
// Receives mode, services, guardianState for minors
export default function AuthForm({ mode = "login", services, guardianState, referralCode }) {
    // State Management - initialize hook using provided services and state
    const h = useAuthForm({ mode, auth: services?.auth, guardianState, referralCode });
    // Rendering - pass all hook output and dependencies to layout
    return <AuthFormLayout {...h} />;
}